import { createSlice } from '@reduxjs/toolkit';

const displayModeSlice = createSlice({
    name: 'displayMode',
    initialState: {},
    reducers: {
        getDisplayModeBegin: (state) => {
            state.inProcess = true;
        },
        setDisplayModeBegin: (state) => {
            state.inProcess = true;
        },
        getDisplayModeError: (state) => {
            state.inProcess = false;
        },
        setDisplayModeError: (state) => {
            state.inProcess = false;
        },
        setDisplayModeSuccess: (state) => {
            state.inProcess = false;
        },
        getDisplayModeSuccess: (state, action) => {
            state.inProcess = false;
            state.iconSetType = action.payload;
        }
    }
});

export const {
    getDisplayModeBegin,
    setDisplayModeBegin,
    getDisplayModeError,
    setDisplayModeError,
    setDisplayModeSuccess,
    getDisplayModeSuccess
} = displayModeSlice.actions;

export default displayModeSlice.reducer;


